import {
  PATH_FOLDER_COLLABORATIONS_NEW,
  PATH_FOLDER_MISSIONS_NEW,
} from '../../../app/constants/paths.constant';
import type { SplitButtonOption } from '../../../components/SplitButton';

export enum MissionCreationOptionEnum {
  Simple = 'simple',
  Collaboration = 'collaboration',
}

export const MISSION_CREATION_OPTIONS: readonly SplitButtonOption[] = [
  { key: MissionCreationOptionEnum.Simple, label: 'Mission simple' },
  { key: MissionCreationOptionEnum.Collaboration, label: 'Collaboration' },
];

export const MISSION_CREATION_PATH_BY_OPTION: Readonly<
  Record<string, string | undefined>
> = {
  [MissionCreationOptionEnum.Simple]: PATH_FOLDER_MISSIONS_NEW,
  [MissionCreationOptionEnum.Collaboration]: PATH_FOLDER_COLLABORATIONS_NEW,
};
